import { render, staticRenderFns } from "./ManageStoreSellerZoneTable.vue?vue&type=template&id=0edf282b"
import script from "./ManageStoreSellerZoneTable.vue?vue&type=script&lang=js"
export * from "./ManageStoreSellerZoneTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports